import React from 'react';

const ImageChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M6 18h12V6H6v12zM4 4h16v16H4V4z" />
        <path d="M17 9.5c0-.8-.7-1.5-1.5-1.5S14 8.7 14 9.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5zM17 16l-2.7-3-1.3 1-2-2.9L7 16h6.9z" />
    </svg>
);

ImageChunkySvg.displayName = 'ImageChunkySvg';
export default ImageChunkySvg;
